import React, { useEffect, useState } from 'react';
import { NotificationContainer } from 'react-notifications';

import { session, socket } from './controllers/session';
import { createCookie, readCookie } from './controllers/cookies';

import HeaderBar from './components/HeaderBar';
import RightMenu from './components/RightMenu';
import Modal from './components/Modal';
import ModRP, { ModuleRP } from './components/ModRP';
import Cookies from './components/Cookies';
import Footer from './components/Footer';

if (!readCookie('lang')) createCookie('lang', 'FR', 365);
if (!readCookie('theme')) createCookie('theme', 'DARK', 365);

const App = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [update, setUpdate] = useState(0);
    const [adminOn, setAdminOn] = useState(false);
    const [locale, setLocale] = useState(readCookie('lang') || 'FR');
    const [theme, setTheme] = useState(readCookie('theme') || 'DARK');
    let isConnected = false;

    useEffect(() => {
        if (!isConnected && session) {
            session.init(setUpdate, setMenuOpen);
        }
        if (readCookie('lang') !== locale) {
            createCookie('lang', locale, 365);
            ModuleRP.changeLocale(locale);
            session.changeLocale(locale);
        }
        if (readCookie('theme') !== theme) {
            createCookie('theme', theme, 365);
        }
        return () => {
            isConnected = true;
        };
    }, [menuOpen, adminOn, update, locale, theme]);

    return (
        <>
            <NotificationContainer />

            <Modal
                session={session}
                locale={locale}
            />

            <HeaderBar
                socket={socket}
                session={session}
                setMenuOpen={setMenuOpen}
                setAdminOn={setAdminOn}
                locale={locale}
                setLocale={setLocale}
                theme={theme}
            />

            {menuOpen ?
                <RightMenu
                    setMenuOpen={setMenuOpen}
                    session={session}
                    setLocale={setLocale}
                    locale={locale}
                    theme={theme}
                    setTheme={setTheme}
                /> : ''}

            <ModRP locale={locale} theme={theme} />

            <Cookies session={session} locale={locale} />

            <Footer locale={locale} theme={theme} />
        </>
    );
};

export default App;
